import React, { useEffect, useMemo, useState } from 'react';
import { Input, Select } from '@components/atoms';
import { css } from '@emotion/react';
import { UserPermission } from '@components/organisms';
import styled from '@emotion/styled';
import { PwValidationStyle } from '@pages/Login/style';
import { checkName } from '@pages/Popup/CreateAccount';
import { CommonValidationStyle, NameValidationStyle } from '@pages/Popup/CreateAccount/styles';
import { PWD_REGEX, REGEX_WRONG_SPECIAL } from '@variables/utils';
import { REGEX_EMAIL_TEXT2 } from '@components/templates/Fields/MyAccount';

const UserDetailField = ({
  activated,
  createdDate,
  email,
  firstName,
  lastName,
  permissionCombination,
  toDate,
  userId,
  onChange,
  valid,
  setValid,
  password = '',
}: any) => {
  /**
   * pwd valid
   * @param pwd
   */
  const checkPWD = (pwd: string) => {
    if (!pwd) return 'none';
    if (userId === pwd) {
      return 'sameidpwd';
    } else if (!PWD_REGEX.test(pwd) || REGEX_WRONG_SPECIAL.test(pwd)) {
      return 'regrex';
    }
    return '';
  };

  return (
    <>
      <tbody>
        <tr>
          <th>Create Date</th>
          <td>{createdDate}</td>
          <th>Account</th>
          <td>
            <InlineTdWrapper>
              <Select
                list={[
                  {
                    label: 'Activated',
                    value: 'true',
                    selected: activated,
                  },
                  {
                    label: 'Deactivated',
                    value: 'false',
                    selected: !activated,
                  },
                ]}
                onSelected={(e) => {
                  onChange({
                    target: { name: 'activated', value: e.value === 'true' },
                  });
                }}
                styles={css`
                  margin: auto 0;
                  width: 100%;
                `}
              />
            </InlineTdWrapper>
          </td>
        </tr>
        <tr>
          <th>ID</th>
          <td>{userId}</td>
          <th>Name</th>
          <td>
            <InlineTdWrapper>
              <Input
                type="text"
                name={'firstName'}
                value={firstName}
                styles={css`
                  ${CommonValidationStyle};
                  ${NameValidationStyle};
                  input ~ div::after {
                    font-size: 12px !important;
                    top: 90% !important;
                  }
                `}
                onChange={(e) => {
                  e.target.dataset['invalid'] = '';
                  onChange(e);
                }}
                onBlur={(e) => {
                  let clone = JSON.parse(JSON.stringify(valid));
                  const result = checkName(e.target.value);
                  e.target.dataset['invalid'] = result;
                  if (result) {
                    clone.fstName = true;
                    setValid(clone);
                  } else {
                    clone.fstName = false;
                    setValid(clone);
                  }
                }}
                required
              />
              <Input
                type="text"
                name={'lastName'}
                value={lastName}
                styles={css`
                  ${CommonValidationStyle};
                  ${NameValidationStyle};
                  input ~ div::after {
                    font-size: 12px !important;
                    top: 90% !important;
                  }
                `}
                onChange={(e) => {
                  e.target.dataset['invalid'] = '';
                  onChange(e);
                }}
                onBlur={(e) => {
                  let clone = JSON.parse(JSON.stringify(valid));
                  const result = checkName(e.target.value);
                  e.target.dataset['invalid'] = result;
                  if (result) {
                    clone.lastName = true;
                    setValid(clone);
                  } else {
                    clone.lastName = false;
                    setValid(clone);
                  }
                }}
                required
              />
            </InlineTdWrapper>
          </td>
        </tr>
        <tr>
          <th>Password</th>
          <td colSpan={3}>
            <Input
              className="width-limit"
              type="password"
              name={'password'}
              value={password}
              onChange={(e) => {
                if (e.target.value.length > 50) return;
                e.target.dataset['invalid'] = '';
                onChange(e);
              }}
              onBlur={(e) => {
                let clone = JSON.parse(JSON.stringify(valid));

                if (!e.target.value) {
                  e.target.dataset['invalid'] = '';
                  clone.pwd = false;
                  setValid(clone);
                  return;
                } else {
                  const result = checkPWD(e.target.value);
                  e.target.dataset['invalid'] = result;
                  if (result) {
                    clone.pwd = true;
                    setValid(clone);
                  } else {
                    clone.pwd = false;
                    setValid(clone);
                  }
                }
              }}
              styles={PwValidationStyle}
              required
            />
          </td>
        </tr>
        <tr>
          <th>Account valid duration</th>
          <td>
            <Input
              type="date"
              name={'toDate'}
              value={`${toDate}`}
              onChange={(e) => onChange(e)}
              props={{
                min: new Date().toISOString().split('T')[0],
              }}
            />
          </td>
          <th rowSpan={2}>Permissions to Use</th>
          <UserPermissionTableDataCell rowSpan={2}>
            <UserPermission
              targetPermission={permissionCombination}
              setTargetPermission={(e: string) => {
                onChange({
                  target: { name: 'permissionCombination', value: e },
                });
              }}
            />
          </UserPermissionTableDataCell>
        </tr>

        <tr>
          <th>Email address</th>
          <td>
            <Input
              type="text"
              name={'email'}
              value={email}
              onChange={(e) => {
                e.target.dataset['invalid'] = '';
                onChange(e);
              }}
              onBlur={(e) => {
                let clone = JSON.parse(JSON.stringify(valid));

                if (!REGEX_EMAIL_TEXT2.test(e.target.value)) {
                  e.target.dataset['invalid'] = 'true';
                  clone.email = true;
                  setValid(clone);
                  return;
                }

                clone.email = false;
                setValid(clone);
                e.target.dataset['invalid'] = '';
              }}
            />
          </td>
        </tr>
      </tbody>
    </>
  );
};

const InlineTdWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;

  & > div:nth-of-type(1) {
    margin-right: 20px;
  }

  & > div {
    width: calc(50% - 10px);
  }
`;

const UserPermissionTableDataCell = styled.td``;
export default UserDetailField;
